import { Dispatch } from "redux";
import {
  getSubModules,
  createSubModule,
  updateSubModule,
  deleteSubModule,
  getSubModuleById,
  getSubModuleByPojectId,
} from "../../services/SubModuleService";
import { SubModule } from "../../types/SubModule";
import axios from "axios";
import api from "../../config/api";

export enum SubModuleActionType {
  FETCH_SUB_MODULES = "FETCH_SUB_MODULES",
  FETCH_SUB_MODULES_PROJECTID = "FETCH_SUB_MODULES_PROJECTID",
  ADD_SUB_MODULE = "ADD_SUB_MODULE",
  EDIT_SUB_MODULE = "EDIT_SUB_MODULE",
  DELETE_SUB_MODULE = "DELETE_SUB_MODULE",
}

export interface FetchSubModules {
  type: SubModuleActionType.FETCH_SUB_MODULES;
  data: SubModule[];
}
export interface FetchSubModulesProjecId {
  type: SubModuleActionType.FETCH_SUB_MODULES_PROJECTID;
  data: SubModule[];
}

export interface AddSubModule {
  type: SubModuleActionType.ADD_SUB_MODULE;
  data: SubModule;
}

export interface EditSubModule {
  type: SubModuleActionType.EDIT_SUB_MODULE;
  data: SubModule;
}

export interface DeleteSubModule {
  type: SubModuleActionType.DELETE_SUB_MODULE;
  data: number;
}

export type SubModuleAction =
  | FetchSubModules
  | AddSubModule
  | EditSubModule
  | DeleteSubModule
  | FetchSubModulesProjecId;

export const fetchSubModules = () => async (dispatch: Dispatch) => {
  const data = await getSubModules();
  dispatch<FetchSubModules>({
    type: SubModuleActionType.FETCH_SUB_MODULES,
    data,
  });
};
export const fetchSubModulesByProject =
  (projectId: number) => async (dispatch: Dispatch) => {
    try {
      const response = await getSubModuleByPojectId(projectId);

      dispatch<FetchSubModulesProjecId>({
        type: SubModuleActionType.FETCH_SUB_MODULES_PROJECTID,
        data: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered submodules", error);
    }
  };

export const addSubModule = (sub: SubModule) => async (dispatch: Dispatch) => {
  const response = await createSubModule(sub);
  dispatch<AddSubModule>({
    type: SubModuleActionType.ADD_SUB_MODULE,
    data: response.data.data,
  });
};

export const editSubModule =
  (id: number, sub: SubModule) => async (dispatch: Dispatch) => {
    const response = await updateSubModule(id, sub);
    dispatch<EditSubModule>({
      type: SubModuleActionType.EDIT_SUB_MODULE,
      data: response.data.data,
    });
  };

export const deleteSubModuleById =
  (id: number) => async (dispatch: Dispatch) => {
    await deleteSubModule(id);
    dispatch<DeleteSubModule>({
      type: SubModuleActionType.DELETE_SUB_MODULE,
      data: id,
    });
  };
